const config = {
	images: {
		imageSizes: [240, 480, 960, 1920, 3840],
		fallbackSize: 960,
		thumbnailSize: 50,
		quality: 90,
	},
};

export default config;
